export default {
  commons: {
    changeCustomer: "Seleziona Cliente",
    deleteItemConfirmation: "Vuoi veramente eliminare questo elemento?",
    notAvailable: "N/D",
    successNotificationTitle: "Operazione completata!",
    taskevents: {
      phone: "Telefonata",
      reminder: "Promemoria",
      note: "Nota",
      visit: "Visita",
      appointment: "Appuntamento",
      task: "Task",
      editNote: "Modifica Nota",
      newNote: "Nuova Nota",
    },
    searchPlaceholder: "Cerca...",
    all: "Tutti",
    save: "Salva",
    close: "Chiudi",
    noElements: "Nessun elemento trovato",
    unsupportedBrowser:
      "Attenzione! Il browser che stai utilizzando non è supportato, prova ad utilizzare Edge o Chrome.",
    noData: "Nessun dato disponibile",
    setGoalAgentCommission: "Imposta obiettivo",
    setDocumentsSummaryType: "Tipo riepilogo",
    update: "Aggiorna",
    filter: "Filtra",
    required: "obbligatorio",
    logout: "Logout",
    back: "Indietro",
    urgentDelivery: "Urgente",
    takePackage: "Presa",
    scanBarcode: "Inquadra barcode",
    startNavigator: "Avvia navigatore",
    showNote: "Visualizza Nota",
    cashOnDelivery: "Contrassegno",
    error: "Errore",
    nothingElse: "Nessuno",
  },
  comps: {
    DateFilter: {
      selectPeriod: "Seleziona il periodo",
      today: "Oggi",
      yesterday: "Ieri",
    },
    DocumentFilter: {
      tipology: "Tipologia",
    },
    WarehouseFilter: {
      venue: "Sede",
      modalTitle: "Seleziona magazzino",
      apply: "Ok, fatto",
    },
    TypeDocumentsSummaryFilter: {
      modalTitle: "Tipo riepilogo",
      apply: "Ok",
      cancel: "Chiudi",
    },
    TypeSalesBrandFilter: {
      modalTitle: "Marca",
      cancel: "Chiudi",
      reset: "Annulla",
    },
    ProductFilter: {
      advancedSearch: "Ricerca avanzata",
      selectSeries: "Serie",
      selectBrand: "Marca",
      selectLine: "Linea",
      searchText: "Incrocia con codice o descrizione (opzionale)",
      search: "Cerca",
      next: "Prosegui",
      noData: "Nessun dato disponibile",
    },
    SimpleModal: {
      reset: "Reset",
      cancel: "Annulla",
      apply: "Salva",
    },
    ContactDetail: {
      addContact: "Aggiungi contatto",
      editContact: "Modifica contatto",
      enableNewsletter: "Abilita ricezione Newsletter",
      title: "Titolo",
      name: "Nome contatto",
      department: "Reparto",
      email: "Email",
      phone: "Telefono",
      mobile: "Cellulare",
      notes: "Note",
      insert: "Aggiungi",
      change: "Modifica",
    },
    NavigationBar: {
      advancedSearch: "Ricerca avanzata",
      articles: "articoli",
      changeCustomer: "Cambia",
      chooseAgent: "Scegli agente...",
      chooseWarehouse: "Scegli filiale...",
    },
    CustomerChangeModal: {
      title: "Cambia cliente",
      searchPlaceholder: "Cerca cliente...",
      search: "Cerca",
    },
    TagChangeModal: {
      title: "Cambia tag",
      searchPlaceholder: "Cerca tag...",
      search: "Cerca",
    },
    SearchInput: {
      placeholder: "Cerca",
    },
    DataTable: {
      noRows: "Nessun elemento trovato",
      pagination: {
        prev: "Precedente",
        next: "Successiva",
      },
    },
    CustomerMap: {
      startNavigation: "Avvia Navigazione",
    },
    PersonalData: {
      title: "Dati anagrafici",
      businessName: "Ragione sociale",
      vat: "Partita IVA",
      code: "Codice",
      officeAddress: "Indirizzo",
      officePlace: "Località",
      reference: "Riferimento",
      payment: "Pagamento",
      contentious: "Contenzioso",
      agent: "Agente",
      category: "Categoria",
      phone: "Telefono",
      fax: "Fax",
      email: "Email",
      website: "Sito web",
      actionRefresh: "Ricarica",
    },
    LatestActivities: {
      title: "Ultime attività",
      lastVisit: "Ultima visita",
      offer: "Offerta",
      order: "Ordine",
      sale: "Vendita",
      today: "oggi",
      yesterday: "ieri",
      actionRefresh: "Ricarica",
    },
    CreditData: {
      title: "Fido",
      notesToBill: "Bolle da fatturare",
      accountBalance: "Saldo contabile",
      openOrders: "Ordini aperti",
      exposition: "Esposizione",
      remainingCredit: "Fido residuo",
      credit: "Fido",
      noCreditData: "Nessun dato di fido disponibile",
      actionRefresh: "Ricarica",
    },
    RevenueChart: {
      noRevenueData: "Nessun dato di fatturato disponibile",
      actionRefresh: "Ricarica",
      title: "Fatturato merce",
    },
    EvaluationIndices: {
      title: "Indici di valutazione",
      actionRefresh: "Ricarica",
      revenue: "Fatturato",
      margin: "Margine",
      documents: "Documenti",
      rows: "Righe",
      ranking: "Classifica",
      noEvaluation: "Non sono presenti valutazioni per questo cliente",
      lastYear: "Ultimi 12 mesi",
      lastMonth: "Ultimi 30 gg",
      value: "Valore",
      totals: "Totali",
      position: "Posizione",
      average: "Media",
      number: "Numero",
      variation: "Variazione",
      rating: "Valutazione",
    },
    CartArticleModal: {
      articleCode: "Cod. articolo",
      articleCodePlaceholder: "Es*: fdb925",
      articleSearch: "Cerca",
      title: "Aggiungi articolo",
      titleChange: "Modifica articolo",
      applyButton: "Aggiungi",
      applyButtonChange: "Modifica",
      removeButton: "Elimina articolo",
      quantity: "Quantità",
      rowType: "Tipo riga",
      price: "Prezzo",
      discount1: "Sc. 1",
      discount2: "Sc. 2",
      discount3: "Sc. 3",
      discount4: "Sc. 4",
      discounts: "Sconti",
      description: "Descrizione",
      descriptionPlaceholder: "Descrizione articolo editabile",
      addNote: "+ Aggiungi nota",
      showMore: "+ Mostra tutto",
      showLess: "- Mostra meno",
      recapNet: "Netto",
      recapLast: "Ultimo",
      recapDiscount: "Sconto",
      recapCost: "Costo",
      recapMargin: "Margine",
      availability: "Disponibile",
      societyAvailability: "Nella rete",
      subsidiaryAvailability: "In sede",
      deliveryDate: "Data consegna",
      incrementError: "Accetta solo multipli di {0}",
      commission:"Provvigione"
    },
    CartExpenseModal: {
      title: "Aggiungi spesa",
      applyButton: "Aggiungi",
      quantity: "Quantità",
      rowType: "Tipo riga",
      price: "Prezzo",
      discount1: "Sc. 1",
      discount2: "Sc. 2",
      discount3: "Sc. 3",
      discount4: "Sc. 4",
      discounts: "Sconti",
      description: "Descrizione",
      descriptionPlaceholder: "Descrizione spesa editabile",
      addNote: "+ Aggiungi nota",
      titleChange: "Modifica spesa",
      applyButtonChange: "Modifica",
      removeButton: "Elimina spesa",
    },
    CartCommentModal: {
      titleChange: "Modifica commento",
      rowType: "Tipo riga",
      notes: "Note",
      description: "Descrizione",
      title: "Aggiungi commento",
      applyButton: "Aggiungi",
      applyButtonChange: "Modifica",
      removeButton: "Elimina commento",
    },
    DocumentFinalizationModal: {
      title: "Concludi documento",
      notes: "Note",
      vector: "Vettore",
      mode: "Porto",
      notesPlaceholder: "Aggiungi una nota al documento...",
      delivery: "Spedizione",
      applyButton: "Invia",
      totalProcessing: "Evasione totale",
      document: "Documento a seguire",
    },
    StatusModal: {
      closeButton: "Chiudi",
    },
    ConfirmModal: {
      cancelButton: "Cancella",
      confirmButton: "Conferma",
    },
    ProductData: {
      title: "Dati articolo",
      mistralCode: "Cod. Mistral",
      description: "Descrizione",
      brand: "Marca",
      line: "Linea",
      supplier: "Fornitore abit.",
      series: "Serie",
      manufacturerArticle: "Art. produttore",
      technicalCode: "Cod. tecnico",
      replacedArtCode: "Art. sostituito",
      barCode: "Barcode",
      note: "Note",
      availability: "Disponibilità",
      cost: "Acquisto",
      netPrice: "Netto",
      priceMargin: "Margine",
      priceList: "Vendita",
      position: "Posizione",
      discount: "Sconto",
      minPurchaseQnt: "Q.tà min. acquistabile",
      promotion:"Promozione"
    },
    TemplateBox: {
      actionEdit: "Modifica",
      actionDelete: "Elimina",
    },
    StatisticsFiltersModal: {
      title: "Seleziona dati",
    },
    StatisticsTemplateEditModal: {
      title: "Modifica titolo",
      templateNamePlaceholder: "",
      applyButtonLabel: "Modifica",
    },
    StatisticsTemplateCreateModal: {
      title: "Salva report",
      templateNamePlaceholder: "Titolo",
      applyButtonLabel: "Salva",
    },
    StatisticsColumnsSelectorModal: {
      title: "Mostra colonne",
    },
    StatisticsExportModal: {
      title: "Esporta",
    },
    StatisticsTable: {
      sales: {
        code: "Cod",
        description: "Descrizione",
        quantity: "Qtà",
        value: "Fatturato",
        cost: "Costo",
        marginPercent: "Margine %",
        marginAmount: "Margine €",
        incidence: "Inc.%",
        progIncidence: "IncPro%",
        deltaMarginPercent: "Margine %",
        deltaValue: "Fatturato",
        deltaQuantity: "Qtà",
        deltaCost: "Costo",
        deltaMarginAmount: "Margine €",
        priceList: "Listino",
        deltaPriceList: "Listino",
        wastePercent: "Scarto %",
        deltaWastePercent: "Scarto %",
      },
      purchases: {
        code: "Cod",
        description: "Descrizione",
        quantity: "Qtà",
        value: "Valore",
        incidence: "Inc.%",
        progIncidence: "IncPro%",
        deltaValue: "Valore",
        deltaQuantity: "Qtà",
      },
      stock: {
        code: "Cod",
        description: "Descrizione",
        quantity: "Qtà",
        value: "Valore",
        incidence: "Inc.%",
        progIncidence: "IncPro%",
        deltaValue: "Valore",
        deltaQuantity: "Qtà",
      },
      mix: {
        code: "Cod",
        description: "Descrizione",
        deltaIR: "Delta",
        deltaStock: "Delta",
        deltaPurchase: "Delta",
        deltaMargin: "Delta",
        deltaRevenue: "Delta",
        deltaCost: "Delta",
        deltaQtySales: "Delta",
        deltaQtyPurchase: "Delta",
        deltaQtyStock: "Delta",
      },
      "customer-backorder": {
        code: "Cod",
        description: "Descrizione",
        quantity: "Qtà",
        value: "Fatturato",
        cost: "Costo",
        marginPercent: "Margine %",
        marginAmount: "Margine €",
      },
      "supplier-backorder": {
        code: "Cod",
        description: "Descrizione",
        quantity: "Qtà",
        value: "Costo",
        cost: "Costo",
        marginPercent: "Margine %",
        marginAmount: "Margine €",
      },
      "offers-analysis": {
        code: "Cod",
        description: "Marca",
        open: "Aperte",
        welded: "Saldate",
        canceled: "Annullate",
        totals: "Totali",
        openAmount: "Aperte (€)",
        weldedAmount: "Saldate (€)",
        canceledAmount: "Annullate (€)",
        totalsAmount: "Totali (€)",
      },
      "orders-analysis": {
        code: "Cod",
        description: "Descrizione",
        quantity: "Qtà",
        value: "Fatturato",
        cost: "Costo",
        marginPercent: "Margine %",
        marginAmount: "Margine €",
        incidence: "Inc.%",
        progIncidence: "IncPro%",
        deltaMarginPercent: "Margine %",
        deltaValue: "Fatturato",
        deltaQuantity: "Qtà",
        deltaCost: "Costo",
        deltaMarginAmount: "Margine €",
      },
      deltaHeader: "Delta",
      genericSubtitle: "Dal {0} al {1}",
      stockSubtitle: "Periodo: {0}",
    },
    StatisticsTableHeader: {
      period: "Periodo dal {0} al {1}",
    },
    InProgress: {
      title: "Attività consigliate",
      task: "Task aperti",
      offers: "Offerte",
      meeting: "Appuntamenti pianificati",
      unsolved: "Insoluti",
      tag: "Nuovi Tag",
      shared: "Condiviso",
      expired: "Scaduto",
      customersAtRisk: "Clienti a rischio",
    },
    DayAnalysis: {
      title: "Analisi del giorno",
      noAnalysisData: "Non sono presenti dati per il giorno selezionato",
      offersCircle: "Offerte",
      ordersCircle: "Ordini",
      renderCircle: "Resi",
      bubblesCircle: "Bolle",
      invoiceCircle: "Fatture",
      receiptCircle: "Scontrini",
      value: "Valore",
      quantity: "Quantità",
    },
    BudgetCharts: {
      title: "Budget",
      noBudgetData: "Non sono presenti dati per l'anno selezionato",
      backorder: "Backorder",
      revenue: "Fatturato",
      progressiveAmount: "Progressivo",
      monthAmount: "Mensile",
    },
    BudgetBranchChart: {
      title: "Budget Filiali",
      noBudgetData: "Non sono presenti dati per l'anno selezionato",
      budget: "badget",
      revenue: "Fatturato filiali",
      filterBranch: "Tutte ...",
      progressiveAmount: "Progressivo",
      monthAmount: "Mensile",
    },
    TaskEventCard: {
      notes: "Note",
      subject: "Oggetto",
      phoneDatePrefix: "Effettuata il",
      visitDatePrefix: "Effettuata il",
      taskDatePrefix: "Creato il",
      reminderCreatedAtPrefix: "Aggiunto il",
      phoneCreatedAtPrefix: "Aggiunto il",
      noteCreatedAtPrefix: "Aggiunta il",
      visitCreatedAtPrefix: "Aggiunta il",
      appointmentCreatedAtPrefix: "Aggiunto il",
      sharedModalTitle: "Seleziona destinatario",
      actionChange: "Modifica",
      actionRemove: "Elimina",
      actionArchive: "Archivia",
      actionView: "Scarica allegato",
      actionClose: "Chiudi",
      actionOpen: "Riapri",
      actionShare: "Condividi con...",
      actionAdd: "Aggiungi relazione",
      actionChecked: "Visionato",
      closed: "Chiuso",
      apply: "Condividi",
      isShared: "Già condiviso",
      shared: "Condiviso",
      customer: "Cliente",
      contact: "Contatto {0}",
      hours: "ore {0}",
    },
    TaskEventCreateModal: {
      title: "Nuova relazione",
    },
    UploadFile: {
      label: "Allega documento",
      uploadFile: "Sfoglia...",
    },
    DynamicFormEdit: {
      yes: "Sì",
      no: "No",
    },
    ProductImageMedia: {
      title: "Immagini",
      addImage: "Aggiungi immagine",
      imageTag: "Tag",
      imageFilename: "File",
    },
    ProductAttachmentMedia: {
      title: "Allegati",
      addAttachment: "Aggiungi allegato",
    },
    AttachmentsModal: {
      title: "Libreria media",
      delete: "Elimina",
    },
    ImagesGalleryModal: {
      title: "Libreria immagini",
      change: "Modifica",
      delete: "Elimina",
    },
    ImageEditorModal: {
      title: "Modifica immagine",
      originalSizes: "Dimensioni originali : {0}",
      crop: "RITAGLIA IMMAGINE",
      aspectRatio: "Rapporto dimensioni:",
      cropboxSize: "Selezione:",
    },
    DashboardBackorder: {
      title: "Analisi Backorder",
      noData: "Non sono presenti dati.",
      backorder: "Backorder",
      opened: "Ordini Aperti",
      expired: "Ordini Scaduti",
      retired: "Appartato",
    },
    DashboardAgentCommissions: {
      title: "Provvigioni",
      noData: "Non sono presenti dati.",
      goal: "Obiettivo",
      commission: "Consuntivo",
    },
    ChangeCommissionGoalModal: {
      title: "Imposta obiettivo",
      searchPlaceholder: "Inserisci valore ...",
      search: "Imposta",
    },
    DashboardDocumentsSummary: {
      title: "Riepilogo",
      noData: "Non sono presenti dati.",
      salesDocuments: "Documenti Vendita",
      orderDocuments: "Ordini",
      total: "Totale",
      table: {
        value: "VALORE",
        qta: "Q.TA'",
      },
    },
    StatisticsPeriodSelectModal: {
      title: "Seleziona periodo",
      stockPeriod: "Data",
      fromDate: "Da",
      toDate: "a",
      compareWith: "Confronto periodo",
      compareStockWith: "Confronta stock",
      stock1: "Stock 1",
      stock2: "Stock 2",
    },
    StatisticsBackorderPeriodModal: {
      title: "Seleziona periodo",
      limitDate: "Data limite",
    },
    DashboardTable: {
      revenue: "Fatturato",
      budget: "Budget",
    },
    CartArticleErrorsModal: {
      applyButton: "Aggiungi",
    },
    CustomerNote: {
      title: "Note",
    },
    CausalModal: {
      title: "Seleziona causale",
      apply: "Ok, fatto",
    },
    RiskChart: {
      title: "Fatturato ultimi 12 mesi",
    },
    CalendarsModal: {
      back: "Indietro",
      update: "Aggiorna",
      continue: "Avanti",
      cancel: "Annulla",
    },
    AgentsBar: {
      agent: "Stai operando come {0}",
      cancel: "Annulla",
    },
    ProductDynamicFilter: {
      firstRanking: "Classifica 1",
      secondRanking: "Classifica 2",
      thirdRanking: "Classifica 3",
      fourthRanking: "Classifica 4",
      fifthRanking: "Classifica 5",
    },
    DestinationDetail: {
      addDestination: "Aggiungi destinazione",
      editDestination: "Modifica destinazione",
      insert: "Aggiungi",
      change: "Modifica",
      businessName: "Ragione sociale",
      address: "Indirizzo",
      postalCode: "Cap",
      locality: "Località",
      province: "Provincia",
    },
    SendModal: {
      title: "Invia documento",
      send: "Invia",
      sendTo: "Invia a",
      or: "Oppure",
      mailInput: "Indica un solo indirizzo email",
      close: "Chiudi",
      inputError: "Errore: inserire una sola email!",
      documentSent: "Documento inviato",
    },
    AddProductCart: {
      label: "Aggiungi al carrello",
    },
    DeliveryToolbar: {
      archived: "Archiviate",
      deliveryProblems: "Mancata consegna",
      notScan: "Salta",
      startNew: "Nuovo Giro",
      reset: "Reset",
      resetSign: "Reset",
      sendSign: "Invia",
      signDocument: "Firma documento",
      manualCode: "Inserimento codice manuale",
    },
    SignedDocumentsToolbar: {
      archived: "Archiviate",
      deliveryProblems: "Mancata consegna",
      notScan: "Salta",
      startNew: "Nuovo Giro",
      reset: "Reset",
      resetSign: "Reset",
      sendSign: "Invia",
      signDocument: "Firma documento",
      manualCode: "Inserimento codice manuale",
    },
    SignedForCourierToolbar: {
      archived: "Archiviate",
      deliveryProblems: "Mancata consegna",
      notScan: "Salta",
      startNew: "Nuovo Giro",
      reset: "Reset",
      resetSign: "Reset",
      sendSign: "Invia",
      signDocument: "Firma documento",
      manualCode: "Inserimento codice manuale",
    },
    TaskSideMenu: {
      shared: "Condiviso",
      contact: "Contatto",
      customer: "Cliente",
      actionEdit: "Modifica",
      actionAdd: "Aggiungi relazione",
      actionView: "Scarica allegato",
      actionShare: "Condividi con...",
      actionArchive: "Chiudi",
      actionDelete: "Elimina",
    },
  },
  views: {
    Login: {
      companyId: "ID Azienda",
      userId: "ID Utente",
      email: "Email",
      password: "Password",
      username: "Username",
      forgotPassword: "Password dimenticata?",
      notRegistered: "Non sei registrato?",
      access: "Accedi",
      continue: "Avanti",
      recoverPassword: "Recupera password",
      goToLogin: "Vai al login",
      loginResetEmail:
        "E’ stata inviata una mail all’indirizzo {0}. Cliccare sul link all’interno per creare una nuova password.",
      loginPasswordExpiredTitle: "Password scaduta.",
      loginPasswordExpiredDesc:
        "La password attuale è scaduta. E’ necessario creare una nuova password.",
      goToCreatePassword: "Crea password",
      createPassword: "Crea password",
      confirmPassword: "Ripeti password",
      error: "Operazione non riuscita",
      passwordAlreadyUsed:
        "La password inserita è già stata utilizzata in passato, si prega di inserire una nuova password",
      ok: "Operazione riuscita",
      passwordSuccessfullyChanged: "Password modificata correttamente",
      emailInvalid: "L'email inserita non è corretta",
      wrongCredentials: "Le credenziali inserite non sono corrette",
      wrongMistralUser: "Utente di Mistral non valido",
      connectionError:
        "Problemi di connessione: il servizio non è raggiungibile, riprovare più tardi",
      userNotFound: "L'utente inserito non è stato trovato",
      userDisabled: "L'utente è disabilitato",
      unmatchingPassword: "Le password inserite non sono uguali",
      lengthRule: "Almeno 10 caratteri",
      specialCharsRule: "Almeno 1 carattere speciale",
      passwordConfirmation: "Le password devono coincidere",
      LoginResetPassword: {
        title: "Crea password",
      },
      LoginRenewPassword: {
        title: "Crea password",
      },
      LoginForgottenPassword: {
        title: "Recupera password",
      },
      LoginCreatePassword: {
        title: "Primo accesso",
      },
      LoginAccess: {
        title: "Accedi",
      },
      LoginSocietySelection: {
        title: "Seleziona società",
      },
    },
    Unregistered: {
      demoAlert:
        "L’accesso a Naviga è riservato ai clienti di Mistral in possesso di una licenza dedicata. Se vuoi visionare le funzionalità della app e scoprire le sue potenzialità, puoi accedere alla versione demo.",
      accept: "Accedi alla demo",
      discard: "Prosegui",
    },
    CustomersList: {
      viewTitle: "Ricerca clienti",
      code: "Codice",
      phone: "Telefono",
      city: "Città",
      email: "Email",
      noCustomers: "Non sono presenti clienti",
      potentialCustomer: "Potenziale",
    },
    CustomerDocuments: {
      viewTitle: "Documenti",
      documents: "Documenti",
      documentsNumber:
        "{count} Documenti | {count} Documento | {count} Documenti",
      returns: "Resi",
      sales: "Vendite",
      orders: "Ordini",
      offers: "Offerte",
      viewDocument: "Visualizza",
      showPdf: "Scarica PDF",
      table: {
        documents: "Documento",
        date: "Data",
        location: "Località",
        reference: "Riferimento",
        branch: "Filiale",
        value: "Valore",
        warehouse: "Fil",
        user: "Utente",
      },
    },
    CustomerContacts: {
      viewTitle: "Contatti",
      phone: "Telefono",
      mobile: "Cellulare",
      email: "Email",
      department: "Reparto: ",
      noContacts: "Non sono presenti contatti per questo cliente",
      actionShare: "Condividi",
      actionDelete: "Elimina",
      actionEdit: "Modifica",
    },
    CustomerOrders: {
      viewTitle: "Ordini aperti",
      documents: "Documenti",
      documentsNumber:
        "{count} Documenti | {count} Documento | {count} Documenti",
      value: "Valore",
      residue: "Residuo",
      totals: "Totali",
      viewDocument: "Visualizza",
      analysis: "Analisi",
      margins: "Margine",
      showPdf: "Scarica PDF",
      belanceOrder: "Saldo Ordine",
      editAction: "Modifica",
      sendAction: "Invia documento",
      table: {
        documents: "Documento",
        date: "Data",
        location: "Località",
        delivery: "Consegna",
        reference: "Riferimento",
        value: "Valore",
        residue: "Residuo",
        warehouse: "Fil",
        user: "Utente",
      },
    },
    CustomerOffers: {
      title: "Offerte aperte",
      documents: "Documenti",
      documentsNumber:
        "{count} Documenti | {count} Documento | {count} Documenti",
      totals: "Totali",
      value: "Valore",
      viewDocument: "Visualizza",
      showPdf: "Scarica PDF",
      margins: "Margine",
      sendAction: "Invia documento",
      table: {
        documents: "Documento",
        date: "Data",
        warehouse: "Fil",
        reference: "Riferimento",
        user: "Utente",
        value: "Valore",
      },
    },
    CustomerConsignmentPayment: {
      viewTitle: "Conto Visione",
      documents: "Documenti",
      document:"Documento",
      datdoc:"Data Documento",
      warehouse:"Magazzino",
      valmer: "Valore",
      totres: "Residuo",
      numrig:"Riga",
      codart:"Articolo",
      desart:"Descrizione",
      qtadoc:"Qnt.",
      valrig:"Valore",
      selectAllCO:"Tutte CO",
      selectAllBO:"Tutte BL", 
      selectAllIN:"Tutte IN",
      selectAllRI:"Tutte RI",
      selectTotalCO:"Seleziona tutti CO",
      selectTotalBO:"Seleziona tutti  BL", 
      selectTotalIN:"Seleziona tutti  IN",
      selectTotalRI:"Seleziona tutti rientro merce",
      selectCO:"CO",
      selectBO:"BL", 
      selectIN:"IN",
      selectRI:"Rientro merce",
      totals:"Totali",
      sendData:"Conferma"
    },
    CustomerBonus: {
      title: "Premi",
      table: {
        codrow: "Cod",
        description: "Descrizione",
        value: "Valore",
        target: "Obiettivo",
        bonus: "Premio",
      },
    },
    CustomerTicketsCashed: {
      title: "Scontrini da incassare",
      documents: "Documenti",
      documentsNumber:
        "{count} Documenti | {count} Documento | {count} Documenti",
      totals: "Totali",
      value: "Valore",
      viewDocument: "Visualizza",
      showPdf: "Scarica PDF",
      table: {
        documents: "Documento",
        date: "Data",
        warehouse: "Fil",
        reference: "Riferimento",
        totDoc: "Totale",
        totInc: "Residuo",
      },
    },
    CustomerDiscounts: {
      title: "Sconti Cliente",
      table: {
        codArt: "Codice",
        desArt: "Descrizione",
        discount1: "Sconto 1",
        discount2: "Sconto 2",
        discount3: "Sconto 3",
        discount4: "Sconto 4",
      },
    },
    CustomerExpirations: {
      viewTitle: "Scadenze",
      receipts: "Effetti",
      bills: "Fatture",
      expirations: "Scaduto",
    },
    BillsTab: {
      documentsNumber:
        "{count} Documenti | {count} Documento | {count} Documenti",
      residue: "Residuo",
      revenue: "Fatturato",
      totals: "Totali",
      table: {
        documents: "Documenti",
        date: "Data",
        residue: "Residuo",
        value: "Valore",
        status: "Stato",
        receipt: "Effetto",
        expiration: "Scadenza",
        notes: "Note",
      },
    },
    ExpirationsTab: {
      documentsNumber:
        "{count} Documenti | {count} Documento | {count} Documenti",
      residue: "Residuo",
      revenue: "Fatturato",
      totals: "Totali",
      table: {
        residue: "Residuo",
        value: "Valore",
        expirations: "Scadenze",
      },
    },
    ReceiptsTab: {
      totals: "Totali",
      documentsNumber:
        "{count} Documenti | {count} Documento | {count} Documenti",
      residue: "Residuo",
      revenue: "Fatturato",
      table: {
        residue: "Residuo",
        value: "Valore",
        expiration: "Scadenza",
        receipt: "Effetto",
      },
    },
    CustomerSales: {
      viewTitle: "Vendite",
      documentsNumber:
        "{count} Documenti | {count} Documento | {count} Documenti",
      returns: "Resi",
      revenue: "Fatturato",
      totals: "Totali",
      table: {
        brand: "Marca",
        code: "Articolo",
        description: "Descrizione",
        sales: "Vendite",
        quantity: "Quantità",
        price: "Prezzo",
        value: "Valore",
        returnsValue: "Resi",
      },
      salesInfoTable: {
        document: "Documento",
        date: "Data",
        quantity: "Q.Tà",
        amount: "Importo",
      },
    },
    ProductsList: {
      last: "Ultimi",
      sales: "Vendite",
      viewTitle: "Ricerca",
      viewTitleWithQuery: "Ricerca per {0}",
      activeFilters: "Filtri attivi:",
      salesSearch: "Cerca nei risultati...",
      brandFilter: "Seleziona Marca",
    },
    LastProductsList: {
      promo: "Promo",
      table: {
        brand: "Marca",
        product: "Articolo",
        description: "Descrizione",
        price: "Listino",
        discount: "Sconto",
        net: "Netto",
        availability: "Disponibile",
        supplier: "Fornitore",
        article: "Articolo",
        alternative: "Cross",
        spareArticle: "Ricambio",
        unimis: "UM",
      },
      warehousesStocksTable: {
        warehouse: "Fil",
        description: "Descrizione",
        available: "Disponibile",
      },
      documentsTable: {
        document: "Documento",
        date: "Data",
        quantity: "Q.TA'",
        amount: "Importo",
      },
    },
    SalesProductsList: {
      table: {
        article: "Codice",
        brand: "Marca",
        description: "Descrizione",
        price: "Listino",
        discount: "Sconto",
        net: "Netto",
        availability: "Disponibile",
        alternative: "Cross",
        unimis: "UM",
      },
      warehousesStocksTable: {
        warehouse: "Fil",
        description: "Descrizione",
        available: "Disponibile",
      },
    },
    ProductCard: {
      title: "Torna alla ricerca",
    },
    ProductAvailabilities: {
      title: "Disponibile",
      table: {
        warehouse: "Fil",
        description: "Descrizione",
        ordered: "Ordinato",
        traveling: "Viaggiante",
        control: "Controllo",
        stock: "Giacenza",
        committed: "Impegnato",
        available: "Disponibile",
      },
    },
    ProductCrossReferences: {
      title: "Alternativi",
      table: {
        brand: "Marca",
        product: "Articolo",
        description: "Descrizione",
        price: "Listino",
        discount: "Sconto",
        net: "Netto",
        availability: "Disponibile",
        supplier: "Fornitore",
      },
    },
    ProductArrivals: {
      title: "Arrivi",
      table: {
        document: "Documento",
        description: "Descrizione",
        date: "Data",
        code: "Fil",
        furnisher: "Cliente",
        customerCode: "Codice",
        delivery: "Consegna",
        quantity: "Quantità",
      },
    },
    ProductReplacer: {
      title: "Ricambi",
      table: {
        article: "Articolo",
        description: "Descrizione",
        brand: "Marca",
        price: "Listino",
        discount: "Sconto",
        net: "Netto",
        availability: "Disponibile",
      },
    },
    ProductHistory: {
      title: "Vendite",
      lastPriceDate: "del {0}",
      search: "Filtra risultati...",
      table: {
        lastPriceDate: "Data",
        code: "Codice",
        customer: "Cliente",
        customerCode: "Codice",
        sales: "Vendite",
        quantity: "Quantità",
        avaragePrice: "Prezzo medio",
        lastPrice: "Ultimo prezzo",
      },
    },
    ProductCommitments: {
      title: "Impegni",
      table: {
        document: "Documento",
        description: "Descrizione",
        date: "Data",
        code: "Fil",
        customer: "Cliente",
        customerCode: "Codice",
        delivery: "Consegna",
        quantity: "Quantità",
      },
    },
    ProductDetail: {
      productsListLink: "Nuova ricerca",
    },
    DocumentDetail: {
      warehouse: "Deposito di partenza",
      destination: "Destinazione",
      customer: "Cliente",
      number: "Numero",
      data: "Data",
      sender: "Spett.le",
      reference: "Riferimento",
      agent: "Agente",
      operator: "Operatore",
      payment: "Pagamento",
      delivery: "Modalità consegna",
      port: "Porto",
      vector: "Vettore",
      packages: "Colli",
      weight: "Peso",
      taxable: "Imponibile",
      iva: "Iva",
      total: "Totale",
      transportDocument: "Documento di trasporto",
      sendEmail: "Invia per email",
      cancel: "Annulla",
      submitOrder: "Trasforma in ordine",
      table: {
        article: "Articolo",
        description: "Descrizione",
        measureUnit: "UM",
        quantity: "Quantità",
        price: "Prezzo",
        discount: "Sconto",
        value: "Valore",
        sent: "Spedito",
        discount1: "Sc1",
        discount2: "Sc2",
        discount3: "Sc3",
        discount4: "Sc4",
        netPrice: "Netto",
      },
    },
    InsertedDocuments: {
      viewTitle: "Documenti aperti",
      deleteAction: "Elimina",
      editAction: "Modifica",
      confirmAction: "Conferma",
      showPdf: "Scarica PDF",
      margins: "Margini",
      sendAction: "Invia documento",
      belanceOrder: "Saldo Ordine",
      confirmTitle: "Avviso",
      confirmMessage: "Per procedere clicca su conferma.",
      analysis: "Analisi",
      attachments:"Documenti",
      table: {
        documents: "Documento",
        date: "Data",
        location: "Località",
        reference: "Riferimento",
        value: "Valore",
        blocked: "Stato",
        warehouse: "Fil",
        user: "Utente",
      },
      DocumentCreateModal: {
        createTitle: "Nuovo documento",
        editTitle: "Modifica documento",
        documentType: "Tipo documento",
        deliveryDate: "Data di consegna",
        reference: "Riferimento",
        destination: "Destinazione",
        referencePlaceholder: "Es.: Mario Rossi",
        createButton: "Avanti",
        editButton: "Modifica",
        warehouse: "Magazzino",
        paymentTpe:"Tipo pagamento"
      },
      DocumentAttachmentsModal:{
        title:"Lista Allegati",
        downloadAll:"Scarica",
        selectAll:"Seleziona tutto",
        close:"Chiudi"
      }
    },
    Cart: {
      title: "Carrello",
      customer: "Cliente",
      insertedAt: "Data",
      name: "Nome",
      phone: "Telefono",
      email: "Email",
      document: "Documento",
      deliveryDate: "Consegna",
      reference: "Riferimento",
      destination: "Destinazione",
      addArticle: "Articolo",
      addExpense: "Spesa",
      addComment: "Commento",
      closeDocument: "Concludi",
      businessName: "Ragione sociale",
      subsidiary: "Filiale",
      payment: "Pagamento",
      actionEdit: "Modifica testata",
      table: {
        articleCode: "Articolo",
        brand: "Marca",
        description: "Descrizione",
        quantity: "Quantità",
        quantity_editable: "Quantità",
        price: "Prezzo",
        discounts: "Sconti",
        net: "Netto",
        notes: "Note",
        tot: "Valore",
        unimis: "UM",
        perprv:"Provvigione",
        valprv:"Valore Provvigione"
      },
    },
    OfferDetail: {
      title: "Conferma righe per {0}",
      closeDocument: "Conferma",
      table: {
        article: "Articolo",
        brand: "Marca",
        description: "Descrizione",
        quantity: "Quantità",
        quantity_editable: "Quantità",
        price: "Prezzo",
        discounts: "Sconti",
        discount1: "Sc. 1",
        discount2: "Sc. 2",
        discount3: "Sc. 3",
        discount4: "Sc. 4",
        net: "Netto",
        notes: "Note",
        date: "Consegna",
      },
    },
    DocumentMargins: {
      title: "Margine {0}",
      totals: "Totali",
      totalFatt: "Totale Fatturato",
      totalCost: "Totale Costo",
      totalMargin: "Totale Margine",
      lastCost: "Ultimo",
      middleCost: "Medio",
      listCost: "Listino",
      table: {
        article: "Articolo",
        description: "Descrizione",
        quantity: "Quantità",
        price: "Prezzo",
        cost: "Costo",
        margin: "Margine %",
        valfat: "Valore fatturato",
        valcos: "Valore costo",
      },
    },
    StatisticsTemplates: {
      sales: {
        title: "Statistiche di vendita",
      },
      purchases: {
        title: "Statistiche di acquisto",
      },
      stock: {
        title: "Statistiche stock",
      },
      mix: {
        title: "Statistiche mix",
      },
      "customer-backorder": {
        title: "Statistiche Backorder Cliente",
      },
      "supplier-backorder": {
        title: "Statistiche Backorder Fornitore",
      },
      "offers-analysis": {
        title: "Statistiche Analisi Offerte",
      },
      "orders-analysis": {
        title: "Statistiche Analisi Ordini Clienti",
      },
      newModel: "Nuovo modello",
    },
    StatisticsDetail: {
      title: "Nuovo report",
      applyPeriod: "Applica",
      removeFirstNodeWarning:
        "Sei sicuro di voler eliminare tutti i filtri e voler tornare alla schermata precedente?",
      columnsButton: "Colonne",
      saveButton: "Salva report",
      exportButton: "Esporta",
      changePeriod: "Cambia",
      actionSave: "Salva",
      actionExport: "Esporta",
      actionColumns: "Colonne",
      sales: {
        quantity: "Quantità",
        value: "Fatturato",
        cost: "Costo",
        marginPercent: "Margine %",
        marginAmount: "Margine €",
        incidence: "Incidenza %",
        progIncidence: "Incidenza progressiva %",
        deltaMargin: "Differenza margine",
        deltaRevenue: "Differenza fatturato",
        priceList: "Listino",
        wastePercent: "Scarto %",
      },
      purchases: {
        quantity: "Quantità",
        value: "Valore",
        incidence: "Incidenza %",
        progIncidence: "Incidenza progressiva %",
        deltaValue: "Differenza valore",
      },
      stock: {
        quantity: "Quantità",
        value: "Valore",
        incidence: "Incidenza %",
        progIncidence: "Incidenza progressiva %",
        deltaValue: "Differenza valore",
      },
      mix: {
        clusters: {
          revenue: "Fatturato",
          margin: "Margine",
          cost: "Costo Venduto",
          purchases: "Acquisti",
          stock: "Stock",
          ir: "Indice di rotazione",
          irShort: "IR",
          qtySales: "Qtà venduta",
          qtyPurchases: "Qtà acquistata",
          qtyStock: "Qtà stock",
        },
      },
      "customer-backorder": {
        quantity: "Quantità",
        value: "Fatturato",
        cost: "Costo",
        marginPercent: "Margine %",
        marginAmount: "Margine €",
      },
      "supplier-backorder": {
        quantity: "Quantità",
        value: "Costo",
        cost: "Costo",
        marginPercent: "Margine %",
        marginAmount: "Margine €",
      },
      "offers-analysis": {
        open: "Aperte",
        welded: "Saldate",
        canceled: "Annullate",
        totals: "Totali",
        openAmount: "Aperte (€)",
        weldedAmount: "Saldate (€)",
        canceledAmount: "Annullate (€)",
        totalsAmount: "Totali (€)",
      },
      "orders-analysis": {
        quantity: "Quantità",
        value: "Fatturato",
        cost: "Costo",
        marginPercent: "Margine %",
        marginAmount: "Margine €",
        incidence: "Incidenza %",
        progIncidence: "Incidenza progressiva %",
        deltaMargin: "Differenza margine",
        deltaRevenue: "Differenza fatturato",
      },
      editNotificationText: "Il report è stato modificato con successo",
      createNotificationText: "Il report è stato creato con successo",
      backWithoutSave:
        "Tornando indietro, perderai tutte le modifiche non salvate, sei sicuro?",
      goBackCancel: "Annulla",
      goBackConfirm: "Ok",
      exportCSV: "Scarica in CSV",
      exportXLS: "Scarica in Excel",
      exportPDF: "Scarica in PDF",
      showColumns: "Mostra colonne",
      showRows: "Mostra/nascondi righe",
      searchButton: "Cerca nel documento",
      toDate: "Ad oggi",
      lastYear: "Anno precedente",
      thisMonth: "Questo mese",
      fromLastMonth: "Al mese scorso",
      lastMonth: "Mese scorso",
      firstQuarter: "1° trimestre",
      secondQuarter: "2° trimestre",
      thirdQuarter: "3° trimestre",
      fourthQuarter: "4° trimestre",
      fullYear: "Anno intero",
      personalized: "Personalizzata",
      predefinedIntervals: "Intervalli predefiniti",
      from: "Da:",
      to: "a:",
      compare: "Confronta",
      compareStock: "Confronta stock",
      all: "Tutto",
      previousPeriod: "Periodo precedente",
      expand: "Espandi/contrai",
      toEndMonth: "A fine mese",
      progressiveData: "Dati progressivi",
    },
    RecommendedActivities: {
      title: "Attività consigliate",
      add: "AGGIUNGI A TASK APERTI",
      delete: "ELIMINA",
    },
    OpenedTasks: {
      title: "Task aperti",
      actionArchive: "Archivia",
      actionHistory: "Storico",
      actionDelete: "Elimina",
      actionClose: "Chiudi",
      archive: "ARCHIVA TASK",
      delete: "ELIMINA",
      searchPlaceholder: "Cerca nei task",
    },
    SharedTasks: {
      title: "Task condivisi",
      actionArchive: "Archivia",
      actionHistory: "Storico",
      actionDelete: "Elimina",
      actionClose: "Chiudi",
      archive: "ARCHIVA TASK",
      delete: "ELIMINA",
    },
    TaskEventFormModal: {
      phoneTitle: "Nuova telefonata",
      reminderTitle: "Nuovo promemoria",
      noteTitle: "Nuova nota",
      visitTitle: "Nuova visita",
      appointmentTitle: "Nuovo appuntamento",
      dateField: "Data",
      timeField: "Ora",
      subjectField: "Oggetto",
      notesField: "Note",
      notesPlaceholder: "Aggiungi una nota...",
      closeEvent: "Chiudi task",
      create: "Crea",
      save: "Salva",
      phoneEdit: "Modifica telefonata",
      reminderEdit: "Modifica promemoria",
      noteEdit: "Modifica nota",
      visitEdit: "Modifica visita",
      appointmentEdit: "Modifica appuntamento",
      sendFile: "Invia promemoria calendario",
    },
    EditTaskFormModal: {
      title: "Nuovo task",
      editTitle: "Modifica task",
      applyLabel: "Crea",
      save: "Salva",
      customerField: "Cliente",
      contactField: "Contatto",
      contactFieldPlaceholder: "Elenco contatti",
      tagField: "Tags",
      subjectField: "Oggetto",
      notesField: "Note",
      notesPlaceholder: "Aggiungi una nota...",
      attachments: "Allegati",
    },
    TagsManagement: {
      title: "Gestione Tags",
      actionAdd: "Aggiungi ad attività",
      actionFlag: "Visionato",
      actionEdit: "Modifica",
      toView: "Da visionare",
      download: "Scarica",
      validFrom: "Valida dal",
      validTo: "al",
      readAll: "Leggi tutto",
      events: "Eventi",
      customerPromotions: "Promozioni clienti",
      suppliersPromotions: "Promozioni fornitori",
      various: "Varie",
    },
    EditTagFormModal: {
      title: "Nuovo tag",
      titleEdit: "Modifica tag",
      subjectField: "Oggetto",
      notesField: "Note",
      notesPlaceholder: "Aggiungi una nota...",
      addButton: "Aggiungi",
      saveButton: "Salva",
      updateButton: "Aggiorna",
      updateTitle: "Aggiorna tag",
      startDate: "Data inizio",
      endDate: "Data fine",
    },
    ReadAllModal: {
      close: "Chiudi",
    },
    CustomerRelations: {
      viewTitle: "Relazioni",
      phone: "Telefonata",
      reminder: "Promemoria",
      note: "Nota",
      visit: "Visita",
      appointment: "Appuntamento",
      task: "Task",
      phones: "Telefonate",
      notes: "Note",
      visits: "Visite",
      appointments: "Appuntamenti",
      tasks: "Tasks",
      searchPlaceholder: "Cerca nelle relazioni...",
      onlyOpened: "Solo aperte",
    },
    CustomerSurvey: {
      title: "Dati CRM",
    },
    CalendarEvents: {
      title: "Calendario",
      closedEvent: "Chiusa",
      today: "Oggi",
    },
    PotentialCustomerModal: {
      title: "Aggiungi Potenziale",
      insert: "Aggiungi",
      change: "Modifica",
      businessName: "Ragione Sociale",
      street: "Indirizzo",
      zipCode: "Cap",
      location: "Località",
      province: "Provincia",
      vatNumber: "Partita Iva",
      fiscalCode: "Codice fiscale",
      category: "Categoria",
      contact: "Contatto",
      email: "Email",
      telephoneNumber: "Telefono",
      notes: "Note",
      category1: "Categoria 1",
      category2: "Categoria 2",
      category3: "Categoria 3",
      category4: "Categoria 4",
      category5: "Categoria 5",
      vatError: "Partita Iva già esistente",
    },
    DailyDocuments: {
      table: {
        documents: "Documento",
        code: "Codice",
        reference: "Riferimento",
        businessName: "Ragione sociale",
        tracking: "Tracking",
        value: "Valore",
      },
      offers: "Offerte",
      orders: "Ordini",
      bubbles: "Bolle",
      receipts: "Scontrini",
      invoices: "Fatture",
      viewDocument: "Visualizza",
      showPdf: "Scarica PDF",
      Analysis: "Analisi",
      renders: "Resi",
      tracking: "Tracking",
    },
    DocumentAnalysis: {
      table: {
        article: "Articolo",
        desart: "Descrizione",
        quantity: "Ordine",
        shipped: "Spedita",
        residue: "Residua",
        ordered: "Ordinata",
        checked: "Controllo",
        stock: "Stock",
        datacons: "Consegna",
        confirmDate: "Conferma",
        tipart: "Tipo",
      },
      offers: "Analisi Offerte",
      orders: "Analisi Ordini",
      title: "Analisi Documento",
      bubbles: "Analisi Bolle",
      receipts: "Analisi Scontrini",
      invoices: "Analisi Fatture",
    },
    BackorderDocuments: {
      table: {
        documentNumber: "Documento",
        referenceNumber: "Riferimento",
        customerCode: "Codice",
        businessName: "Ragione sociale",
        value: "Valore",
        documentDate: "Data",
      },
      title: "Documenti backorder",
      showPdf: "Scarica PDF",
      viewDocument: "Visualizza",
      belanceOrder: "Saldo Ordine",
      analysis: "Analisi",
    },
    BackorderDocumentsRows: {
      table: {
        customerCode: "Codice",
        customer: "Cliente",
        documentNumber: "Documento",
        documentDate: "Data",
        brandCode: "Marca",
        manifacturerCode: "Articolo",
        description: "Descrizione",
        quantity: "Qta",
        deliveryDate: "Consegna",
        confirmDate: "Conferma",
        value: "Valore",
      },
      open: "Aperti",
      expired: "Scaduti",
      title: "Righe backorder",
      showPdf: "Scarica PDF",
      viewDocument: "Visualizza",
      exportXls: "Esporta in Excel",
    },
    RetiredDocuments: {
      table: {
        documentNumber: "Documento",
        referenceNumber: "Riferimento",
        customerCode: "Codice",
        businessName: "Ragione sociale",
        value: "Valore",
        documentDate: "Data",
      },
      title: "Documenti Appartati",
    },
    CustomerDocumetary: {
      viewTitle: "Documentale",
      edit: "Modifica",
      delete: "Elimina",
    },
    CustomerDocumetaryEditModal: {
      edit: "Modifica",
    },
    OffersSolicit: {
      title: "Offerte da sollecitare",
      confirmAction: "Conferma",
      closeAction: "Chiudi",
      createTaskAction: "Crea task",
      viewAction: "Visualizza",
      ignoreAction: "Ignora",
      table: {
        documentNumber: "Documento",
        documentDate: "Data",
        customerCode: "Codice",
        businessName: "Ragione sociale",
        referenceNumber: "Riferimento",
        value: "Valore",
      },
    },
    UnsolvedDocuments: {
      title: "Insoluti",
      createTaskAction: "Crea task",
      viewAction: "Visualizza",
      ignoreAction: "Ignora",
      table: {
        documentNumber: "Fattura",
        documentDate: "Data",
        customerCode: "Codice",
        businessName: "Ragione sociale",
        value: "Valore",
      },
    },
    ExpiredDocuments: {
      title: "Scaduti",
      createTaskAction: "Crea task",
      viewAction: "Visualizza",
      ignoreAction: "Ignora",
      table: {
        documentNumber: "Fattura",
        documentDate: "Data",
        customerCode: "Codice",
        businessName: "Ragione sociale",
        value: "Valore",
      },
    },
    CustomersRisk: {
      title: "Clienti a rischio",
      createTaskAction: "Crea task",
      viewAction: "Visualizza",
      ignoreAction: "Ignora",
      table: {
        customerCode: "Codice",
        businessName: "Ragione sociale",
        location: "Località",
        monthRevenue: "Media ultimi 30 giorni",
        periodRevenue: "Media ultimi 12 mesi",
      },
    },
    CustomersNew: {
      title: "Clienti nuovi",
      table: {
        customerCode: "Codice",
        businessName: "Ragione sociale",
        location: "Località",
      },
    },
    PendingDocuments: {
      title: "Visione aperte",
      table: {
        datsca: "Data Scadenza",
        numdoc: "Documento",
        datdoc: "Data Documento",
        numrif: "Riferimento",
        anacod: "Codice",
        ragsoc: "Ragione Sociale",
        codart: "Codice",
        codmar: "Marca",
        artfor: "Articolo",
        desart: "Descrizione",
        qtadoc: "Quantità",
      },
    },

    ReceiptsNotReceived: {
      title: "Corrispettivi da incassare",
      table: {
        customerCode: "Codice",
        businessName: "Ragione sociale",
        location: "Località",
        value: "Valore Inc.",
      },
    },
    CustomerDestinations: {
      viewTitle: "Destinazioni merce",
      actionShare: "Condividi",
      actionDelete: "Elimina",
      actionEdit: "Modifica",
      noDestinations: "Non sono presenti destinazioni per questo cliente",
      address: "Indirizzo",
      locality: "Località",
    },
    DeliveryStart: {
      viewTitle: "Giro consegne",
      viewSubtitle1: "Inizia il giro scansionando",
      viewSubtitle2: "l'etichetta di un collo qualsiasi della distinta",
      startDelivery: "Inizia giro",
      cancelDelivery: "Annulla",
      manualCode: "Inserisci il Barcode di 9 cifre",
      sendCode: "Procedi",
    },
    DeliveryAddressList: {
      selectDestinationLabel: "Seleziona destinazione",
      confirmAbort: "Attenzione! abbandonare il giro consegna?",
      notValidAddresses:
        "Numerazione non trovata. Premere indietro per inserire un nuovo Barcode",
      btnNewNumber: "Numerazione non trovata. Immettere nuovo Barcode",
      addressNotFound: "Indirizzo non trovato",
    },
    DeliveryDetails: {
      nextPlace: "Prossima destinzione",
      executedWithPackage: "Consegna senza scansione",
      executedWithPackageEnded: "Pacchi consegnati",
      executeWithScanPackage: "Scansiona {numPackage} collo/i",
      executeWithScanPackageEnded: "Scansioni completate",
      package: "collo",
      packages: "colli",
      nextScan: "Prossima scansione",
      scanPackage: "Scansiona {package} pacchi",
      notValidNumber: "Protocollo non valido",
      gotoSign: "Firma {numDocuments} documento/i",
      gotoSignEnded: "Documenti firmati",
      signNotEnabled: "Firma non disponibile",
      gotoPhoto: "Foto non disponibile",
      completed: "Consegna completata",
      confirmComplete: "Confermi di avere completato la consegna?",
    },
    DeliveryArchived: {
      viewTitle: "Lista Archiviati",
    },
    DeliveryEnded: {
      ended: "Giro completato",
      goto: "Torna a",
      startNew: "Inizia nuovo giro",
    },
    DeliveryDocuments: {
      documentsNotFound: "Non sono state trovate bolle {numdis}",
      selectDocument: "Seleziona un documento",
      dateDocument: "del {date}",
    },
    DeliveryProducts: {
      onDelivery: "In consegna",
      quantity: "Q.tà",
    },
    SignedDocStart: {
      viewTitle: "Firma Digitale",
      viewSubtitle1: "Inizia scansionando un DDT",
      startScan: "Scansiona",
      manualCode: "Inserisci il Barcode di 9 cifre",
      sendCode: "Procedi",
    },
    SignedDocDocuments: {
      documentsNotFound: "Non sono state trovate bolle {numdis}",
      gotoSign: "Firma {numDocument} documento",
      fullName: "Nome completo",
      payed: "Pagato",
      issue: "Accetta con riserva",
      signerName:
        "Scrivi nel campo qui sotto il tuo nome completo per poter procedere alla firma digitale.",
      document: {
        documentNumber: "Documento",
        documentDate: "Data",
        customer: "Cliente",
        quantity: "Quantità",
        address: "Indirizzo",
        total: "colli",
        article: "Articolo",
        description: "Descrizione",
        value: "Valore",
        vat: "IVA",
        taxable: "Imponibile",
        um: "UM",
        qta: "Q.tà",
        sent: "Evasa",
        price: "Prezzo",
        discount1: "Sc1",
        discount2: "Sc2",
        discount3: "Sc3",
        discount4: "Sc4",
        netPrice: "Netto",
      },
    },
    SignedDocEnded: {
      ended: "Firma archiviata",
      error: "Problemi nel caricamento della firma",
      startNew: "Chiudi",
      message: "Il documento è stato firmato ed archiviato correttamente",
    },
    SignedCourierStart: {
      viewTitle: "Signa For Courier",
      viewSubtitle1: "Scansiona la distinta e firma digitalmente i documenti",
      startScan: "Scansiona",
      manualCode: "Inserisci il Barcode di 9 cifre",
      sendCode: "Procedi",
    },
    SignedCourierDocuments: {
      documentsNotFound: "Non sono state trovate bolle {numdis}",
      gotoSign: "Firma {numDocument} documento",
      fullName: "Nome completo",
      payed: "Pagato",
      issue: "Accetta con riserva",
      signerName:
        "Scrivi nel campo qui sotto il tuo nome completo per poter procedere alla firma digitale.",
      document: {
        title: "Documento",
        value: "Valore",
        total: "Totale",
        vat: "IVA",
        taxable: "Imponibile",
        name: "Ragione sociale",
        dateDoc: "Data documento",
        dateShip: "Data consegna",
        rif: "Riferimento",
        article: "Articolo",
        description: "Descrizione",
        um: "UM",
        qta: "Q.tà",
        sent: "Evasa",
        price: "Prezzo",
        discount1: "Sc1",
        discount2: "Sc2",
        discount3: "Sc3",
        discount4: "Sc4",
        netPrice: "Netto",
      },
    },
    SignedCourierEnded: {
      ended: "Firma archiviata",
      error: "Problemi nel caricamento della firma",
      startNew: "Chiudi",
      message: "Il documento è stato firmato ed archiviato correttamente",
    },
  },
};
